import { Auth } from '@aws-amplify/auth';

export const authSignOut = () => {
	Auth.signOut();
};
